import { Paths } from '../../constants/paths';
import { Route } from "react-router-dom";
import CashBequestsList from './CashBequestsList';
import SingleCashBequest from './SingleCashBequest';
import { FormComponentProps } from '../FormComponentProps';

export default function CashBequests(props: FormComponentProps) {
  return (
    <>
      <Route path={Paths.CashBequests} exact={true} render={(routeProps) => (
          <CashBequestsList form={props.form} />
        )} />
      <Route path={`${Paths.CashBequests}/:idx`} exact={true} render={(routeProps) => (
          <SingleCashBequest form={props.form} />
        )} />
    </>
  )
}
